var render = function render(_c,_vm){return _c('i',{class:_vm.data.staticClass || _vm.data.class,style:(_vm.props.rotate ? `transform: rotate(${_vm.props.rotate}deg)` : ''),domProps:{"innerHTML":_vm._s(require(`!!html-loader!@root/assets/svg/icons/${_vm.props.name}.svg`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }